export default __webpack_public_path__ + "static/22-c9c21f2112dc5907764c0d75ee35b49b.png";